import { Badge, type BadgeProps } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

export type ListCardHeaderBadge = {
  label: string
  variant?: NonNullable<BadgeProps['variant']>
}

export type ListCardHeaderProps = {
  title: string
  badge?: ListCardHeaderBadge | null
  /** `lg` — standard list cards; `sm` — dense person rows (compact/pipeline). */
  size?: 'lg' | 'sm'
  className?: string
}

/**
 * Primary header for list-style cards: optional status / category pill above the title.
 * Entity-specific cards (job, organisation, etc.) map their domain fields to `badge`.
 */
export function ListCardHeader({ title, badge, size = 'lg', className }: ListCardHeaderProps) {
  return (
    <div
      className={cn(
        'pointer-events-none flex min-w-0 max-w-full flex-col items-start gap-y-2',
        className
      )}
    >
      {badge ? (
        <Badge variant={badge.variant ?? 'secondary'} className="shrink-0">
          {badge.label}
        </Badge>
      ) : null}
      <h3
        data-slot="card-title"
        className={cn(
          'min-w-0 w-full break-words font-semibold',
          size === 'sm' ? 'text-sm' : 'text-lg',
          'leading-none',
        )}
      >
        {title}
      </h3>
    </div>
  )
}
